import React, { useContext, useEffect, useState } from "react";
import "../../css_files/Ticket/Tickets.css";
import axios from "axios";
import { getCookie } from "../../api";
import TicketCard from "./TicketCard";
import TicketTable from "./TicketTable";
import TicketDetail from "./TicketDetail";
import { ToastContainer } from "react-toastify";
import TicketPopup from "./TicketPopup";
import { jwtDecode } from "jwt-decode";
import { triggerscroll } from "../Homepage/Homepage";
import axiosInstance from "../../api";
import TicketInfo from "./TicketInfo";
import Pagination from "../Homepage/Pagination";
import { toast } from "react-toastify";
import AssignedUsersTicket from "./AssignedUsersTicket";

function Tickets({ setEnquiryId, setTicketId, ticketId }) {
  const [ticketsData, setTicketsData] = useState([]);
  const [view, setView] = useState("Grid");
  const [loading, setloading] = useState(false);
  const [showticketdetail, setshowticketdetail] = useState(false);
  const [refresh, setrefresh] = useState(false);
  const [showticketpopup, setshowticketpopup] = useState(false);
  const { setExpiredSession, userData, permissionsdata } =
    useContext(triggerscroll);
  const [ticketType, setTicketType] = useState("Service");
  const [showticketinfo, setshowticketinfo] = useState(false);
  const [ticketinfodata, setticketinfodata] = useState(null);
  const [page, setpage] = useState(1);
  const [pages, setpages] = useState(0);
  const [counts, setcounts] = useState(0);
  const [excelLoading, setExcelLoading] = useState(false);
  const [showAssignedUsers, setShowAssignedUsers] = useState(false);
  const [showAssignedUsersEdit, setShowAssignedUsersEdit] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchTicketsData = async () => {
      setTicketsData([]);
      setloading(true);
      try {
        const ticketRes = await axiosInstance.get(
          `${process.env.REACT_APP_API_URL}/api/v1/Ticket?page=${page}&type=${ticketType}&search=${search}`
        );
        setpages(ticketRes.data.pages);
        setcounts(ticketRes.data.count);
        setTicketsData(ticketRes.data.data);
      } catch (err) {
        console.log(err);
      } finally {
        setloading(false);
      }
    };

    fetchTicketsData();
  }, [refresh, page, ticketType]);

  function readPermission() {
    if (userData.role === "Administrator") return true;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Operations" && x.subHead === "Ticket" && x.isRead === true
    );
    return issatisfied;
  }

  function updatePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Operations" && x.subHead === "Ticket" && x.isUpdate === true
    );
    return !issatisfied;
  }

  function deletePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Operations" && x.subHead === "Ticket" && x.isDelete === true
    );
    return !issatisfied;
  }

  return (
    <>
      <section className="tickets">
        <div className="tickets-nav">
          <h1>Tickets</h1>
          <blockquote>
            <input
              type="search"
              placeholder="Enter Search Keyword (Press Enter Key)"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              value={search}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  setrefresh(!refresh);
                }
              }}
              onInput={(e) => {
                if (e.target.value == "") {
                  setrefresh(!refresh);
                }
              }}
            />

            <button
              onClick={() => setView("Grid")}
              style={{
                backgroundColor: view === "Grid" && "blue",
                color: view === "Grid" && "white",
              }}
            >
              <i class="fa-solid fa-table-cells-large"></i>
            </button>
            <button
              onClick={() => setView("List")}
              style={{
                backgroundColor: view === "List" && "blue",
                color: view === "List" && "white",
              }}
            >
              <i class="fa-solid fa-bars"></i>
            </button>
            {/*excelLoading ? (
              <button>
                <i className="fa-solid fa-rotate-right fa-spin"></i>
              </button>
            ) : (
              <button
                onClick={() => {
                  setExcelLoading(true);
                  axiosInstance
                    .get(
                      `${process.env.REACT_APP_API_URL}/api/Excel/DataBackup?name=Ticket`,
                      { responseType: "blob" }
                    )
                    .then((res) => {
                      const blob = new Blob([res.data]);
                      const url = window.URL.createObjectURL(blob);
                      const a = document.createElement("a");
                      a.download = `Ticket_${new Date().getMilliseconds()}.xlsx`;
                      a.href = url;
                      a.click();
                      window.URL.revokeObjectURL(url);
                      toast.success("Data Exported to Excel Successfully", {
                        position: "bottom-center",
                        theme: "dark",
                      });
                      setExcelLoading(false);
                    })
                    .catch((err) => {
                      console.log(err);
                      setExcelLoading(false);
                    });
                }}
              >
                <i class="fa-solid fa-file-export"></i>
              </button>
            )*/}
          </blockquote>
        </div>
        <blockquote id="ticketToggleinTickets">
          <mark>{ticketType} Tickets</mark>
          <i
            className="fa-solid fa-repeat"
            onClick={() => {
              setTicketType(ticketType === "Service" ? "Parts" : "Service");
              setpage(1);
            }}
          ></i>
          <h3>{counts} records</h3>
        </blockquote>
        {view === "List" ? (
          <div className="ticket-cards-ticket">
            {readPermission() ? (
              loading ? (
                <aside style={{ textAlign: "center", gridColumn: "span 2" }}>
                  <i class="fa-solid fa-snowflake fa-spin fa-3x"></i>
                </aside>
              ) : ticketsData.length > 0 ? (
                ticketsData.map((ticket) => (
                  <TicketCard
                    ticket={ticket}
                    setTicketId={setTicketId}
                    setshowticketpopup={setshowticketpopup}
                    setEnquiryId={setEnquiryId}
                    setShowAssignedUsers={setShowAssignedUsers}
                    setShowAssignedUsersEdit={setShowAssignedUsersEdit}
                  />
                ))
              ) : (
                <aside style={{ textAlign: "center", gridColumn: "span 2" }}>
                  <p>No Records Found</p>
                </aside>
              )
            ) : (
              <aside style={{ textAlign: "center", gridColumn: "span 2" }}>
                <p>You Do Not Have Permission To Read Data</p>
              </aside>
            )}
          </div>
        ) : (
          <TicketTable
            ticketsData={ticketsData}
            setTicketId={setTicketId}
            setshowticketpopup={setshowticketpopup}
            setrefresh={setrefresh}
            refresh={refresh}
            setEnquiryId={setEnquiryId}
            setshowticketdetail={setshowticketdetail}
            setshowticketinfo={setshowticketinfo}
            setticketinfodata={setticketinfodata}
            loading={loading}
            setShowAssignedUsers={setShowAssignedUsers}
            setShowAssignedUsersEdit={setShowAssignedUsersEdit}
            readPermission={readPermission}
            updatePermission={updatePermission}
            deletePermission={deletePermission}
          />
        )}
        <br />

        <Pagination count={pages} pagenumber={page} setpagenumber={setpage} />
      </section>
      {showticketdetail && (
        <TicketDetail
          ticketId={ticketId}
          setshowticketdetail={setshowticketdetail}
          setShowAssignedUsers={setShowAssignedUsers}
          setShowAssignedUsersEdit={setShowAssignedUsersEdit}
          setTicketId={setTicketId}
          showticketdetail={showticketdetail}
        />
      )}
      {showticketpopup && (
        <TicketPopup
          ticketId={ticketId}
          setTicketId={setTicketId}
          setshowticketpopup={setshowticketpopup}
          refresh={refresh}
          setrefresh={setrefresh}
          setShowAssignedUsers={setShowAssignedUsers}
          setShowAssignedUsersEdit={setShowAssignedUsersEdit}
        />
      )}
      {showticketinfo && (
        <TicketInfo
          ticketId={ticketId}
          setshowticketinfo={setshowticketinfo}
          ticketinfodata={ticketinfodata}
        />
      )}
      {showAssignedUsers && (
        <AssignedUsersTicket
          ticketId={ticketId}
          setShowAssignedUsers={setShowAssignedUsers}
          showAssignedUsersEdit={showAssignedUsersEdit}
        />
      )}
    </>
  );
}

export default Tickets;
